import React, { PureComponent } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';
import { quoteFormSelector } from 'ctm-selectors';
import { FormattedInput } from '../formatted_input/formatted_input';
import { Label } from '../label/label';
import { SimpleFlexbox } from '../../flexbox/flexbox';
import { withRules } from '../../../higher_order_components/with_rules';
import styles from './phone_number_toggle.css';

const FormattedInputWithRules = withRules(FormattedInput);

class _PhoneNumberToggle extends PureComponent {

    constructor(props) {
        super(props);
        this.state = {
            isMobile: Boolean(props.mobileValue),
            isPhone: Boolean(props.phoneValue)
        };
    }

    /**
     * Handles the toggling for the trigger
     * fires dispatch to set the value
     */
    onToggle = () => {
        const { mobileValue, phoneValue, mobileId, phoneId, dispatch } = this.props;
        const { isMobile, isPhone } = this.state;
        this.setState({ isPhone: !isPhone });
        if (mobileValue || phoneValue) {
            const identifier = (isMobile || !isPhone) ? mobileId : phoneId;
            dispatch({ type: 'SET_VALUE', value: '', identifier, stateKey: 'vertical.quote' });
        }
    };

    /**
     * gets the input props and returns the component
     * @returns {Node} returns the component based on this.state.isMobile
     */
    getInput = () => {
        const {
            dispatch,
            mobileValue,
            phoneValue,
            mobileId,
            phoneId,
            mobileRules,
            phoneRules,
            ...restProps
        } = this.props;
        const { isMobile, isPhone } = this.state;
        const defaultProps = {
            ...restProps,
            displayErrorMessage: true,
            dispatch,
            metaType: 'tel',
            guide: true,
            minlength: 10,
            addonWidth: 'default'
        };
        const mobileProps = {
            inputType: 'mobile',
            value: mobileValue,
            identifier: mobileId,
            placeholder: '04xx xxx xxx',
            key: 'mobile_input',
            rules: mobileRules
        };
        const phoneProps = {
            inputType: 'landline',
            value: phoneValue,
            identifier: phoneId,
            placeholder: '(0x) xxxx xxxx',
            key: 'phone_input',
            rules: phoneRules
        };
        return (isMobile || !isPhone) ? <FormattedInputWithRules {...defaultProps} {...mobileProps} /> : <FormattedInputWithRules {...defaultProps} {...phoneProps} />;
    };

    /**
     * renders the component
     * @returns {Node} returns the phone number toggle component
     */
    render = () => {
        const { isMobile, isPhone } = this.state;
        const labelText = (isMobile || !isPhone) ? 'Mobile number' : 'Landline number';
        const toggleText = (isMobile || !isPhone) ? 'Other number?' : 'Mobile number?';
        return (
            <SimpleFlexbox display="flex" column>
                <SimpleFlexbox display="flex" className={styles.label_container}>
                    <Label>{labelText}</Label>
                    <a className={styles.toggle} href="javascript:;" onClick={this.onToggle}>
                        {toggleText}
                    </a>
                </SimpleFlexbox>
                {this.getInput()}
            </SimpleFlexbox>
        );
    };

}
_PhoneNumberToggle.propTypes = {
    mobileId: PropTypes.string.isRequired,
    phoneId: PropTypes.string.isRequired,
    phoneValue: PropTypes.string,
    mobileValue: PropTypes.string,
    dispatch: PropTypes.func,
    mobileRules: PropTypes.array,
    phoneRules: PropTypes.array
};

_PhoneNumberToggle.defaultProps = {
    mobileValue: '',
    phoneValue: ''
};
/**
 * maps state to props
 * @param {Object} state the application state
 * @param {Object} props the components props
 * @returns {Node} returns the additonal props from state
 */
const mapStateToProps = (state, props) => {
    const form = quoteFormSelector(state);
    const mobile = form.getIn(props.mobileId.split('.'));
    const phone = form.getIn(props.phoneId.split('.'));
    return {
        mobile,
        phone
    };
};

const PhoneNumberToggle = connect(mapStateToProps)(_PhoneNumberToggle);

export { PhoneNumberToggle, _PhoneNumberToggle };
